export class QuotaStatusFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<QuotaStatus>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<QuotaStatus>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return QuotaStatusFilters.attributeTypeMap;
    }
    constructor() {
    }
}
